import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiPostAuth } from "../../utils/api"; // Use your axios wrapper
import "../../App.css";

export default function GooglePlayReview() {
  const [loading, setLoading] = useState(true);
  const [apps, setApps] = useState([]);
  const [credits, setCredits] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchApps = async () => {
      try {
        const response = await apiPostAuth("google_apps/list_apps.php");
        if (response.result === 1 && Array.isArray(response.app_list)) {
          setApps(response.app_list);
          setCredits(response.google_play_credit);
        } else {
          setApps([]);
        }
      } catch (error) {
        setApps([]);
      } finally {
        setLoading(false);
      }
    };

    fetchApps();
  }, []);

  const handleAddApp = () => {
    navigate("/dashboard/add-google-play-app");
  };

  const handleOpenAppDashboard = (packageName) => {
    navigate(`/dashboard/google-play-review/${packageName}`);
  };

  const handleGetCredits = () => {
    navigate("/dashboard/billing-payment");
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ fontSize: "1.8rem", marginBottom: "10px", color: "#1f2937" }}>
        Google Play Review Reply Automation
      </h1>
      <p style={{ fontSize: "1rem", marginBottom: "20px", color: "#4b5563" }}>
        Easily connect your apps or games and automate review responses on Google Play with AI.
      </p>

      {/* Credits Section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          marginBottom: "30px",
        }}
      >
        <span
          style={{
            fontSize: "1.1rem",
            color: "#1f2937",
            fontWeight: "500",
          }}
        >
          Available Credits: {credits}
        </span>
        <button
          onClick={handleGetCredits}
          className="primary-button"
          style={{ padding: "6px 12px", fontSize: "0.9rem" }}
        >
          Get Credits
        </button>
      </div>

      {/* Add App button always visible below header */}
      <button
        onClick={handleAddApp}
        className="primary-button"
        style={{
          width: "160px",
          textAlign: "center",
          marginBottom: "30px",
        }}
      >
        + Add App
      </button>

      {loading ? (
        <div style={{ textAlign: "center", marginTop: "80px" }}>
          <div className="loading-spinner"></div>
          <p style={{ marginTop: "12px", color: "#4b5563" }}>Loading your connected apps...</p>
        </div>
      ) : apps.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            marginTop: "40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              fontSize: "1.1rem",
              marginBottom: "20px",
              color: "#374151",
              maxWidth: "400px",
            }}
          >
            You haven't connected any apps yet.<br />
            Start by adding your first app.
          </p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          {apps.map((app) => (
            <div
              key={app.package_name}
              style={{
                backgroundColor: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "15px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              }}
            >
              <div>
                <h3 style={{ fontSize: "1.2rem", margin: "0 0 5px 0", color: "#1f2937" }}>
                  {app.app_name}
                </h3>
                <p style={{ fontSize: "0.9rem", margin: "0", color: "#6b7280" }}>
                  Package: {app.package_name}
                </p>
                <p
                  style={{
                    fontSize: "0.85rem",
                    margin: "5px 0 0 0",
                    color: app.is_running === 1 ? "green" : "red",
                  }}
                >
                  {app.is_running === 1 ? "Automation: Running" : "Automation: Not Running"}
                </p>
              </div>
              <button
                onClick={() => handleOpenAppDashboard(app.package_name)}
                className="primary-button"
                style={{ padding: "8px 16px", minWidth: "120px" }}
              >
                View Dashboard
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
